<template>
  <div class="sa-base-category-manage">
    <grid ref="myGrid" :gridConfigUrl="gridConfigUrl">
      <template slot="topSelectMenus" slot-scope="props">
        <grid-top-menu :hide="!props.ids.length > 0" v-if="props.magicalMenuCodes.includes('copy-base-category')" @click="handleCopyBaseCategory">
          复制基础功能
        </grid-top-menu>
      </template>
    </grid>
    <el-dialog :visible.sync="copyDialogVisible" custom-class="whaty-dialog-form" width="880px" @close="handleDialogClose" @open="handleDialogOpen">
      <div slot="title" class="popup-head">
        <span class="popup-tit">复制基础功能</span>
      </div>
      <div class="whaty-common-form" v-loading="loading">
        <div class="popup-body">
          <div class="popup-content">
            <div class="clearfix popup-content-in">
              <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px">
                <div class="form-table" style="width: 50%; float: left">
                  <ul>
                    <div class="form-table-wrap">
                      <div class="form-table-head"><span>复制后名称:<span class="red">*</span></span></div>
                      <div class="form-table-body">
                        <el-form-item prop="newBaseCategoryName" label-width="50" initial="off">
                          <el-input v-model="ruleForm.newBaseCategoryName" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-table-wrap">
                      <div class="form-table-head">复制后编号:</div>
                      <div class="form-table-body">
                        <el-form-item prop="newBaseCategoryCode" label-width="50" initial="off">
                          <el-input v-model="ruleForm.newBaseCategoryCode" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                      </div>
                    </div>

                    <div class="form-table-wrap">
                      <div class="form-table-head">复制新的grid:</div>
                      <div class="form-table-body">
                        <el-radio v-model="ruleForm.isCopyGrid" label="true">是</el-radio>
                        <el-radio v-model="ruleForm.isCopyGrid" label="false">否</el-radio>
                      </div>
                    </div>
                  </ul>
                </div>
                <div class="form-table" style="width: 50%; float: left">
                  <ul>
                    <div class="form-table-wrap">
                      <div class="form-table-head" style="width: 96px;">备注信息:</div>
                      <div class="form-table-body">
                        <el-form-item prop="comment" label-width="50" initial="off">
                          <el-input v-model="ruleForm.comment" placeholder="请输入内容" clearable></el-input>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-table-wrap">
                      <div class="form-table-head" style="width: 96px;">所属站点:</div>
                      <div class="form-table-body">
                        <el-form-item prop="comment" label-width="50" initial="off">
                          <el-select v-model="ruleForm.siteId" clearable>
                            <el-option
                              v-for="site in webSites" :key="site.id" :value="site.id" :label="site.name">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </div>
                    <div class="form-table-wrap">
                      <div class="form-table-head">复制接口关系:</div>
                      <div class="form-table-body">
                        <el-radio v-model="ruleForm.isCopyInterface" label="true">是</el-radio>
                        <el-radio v-model="ruleForm.isCopyInterface" label="false">否</el-radio>
                      </div>
                    </div>
                  </ul>
                </div>
              </el-form>
            </div>
          </div>
        </div>
      </div>
      <div class="popup-foot group" style="text-align: right;">
        <a href="javascript:" class="btn btn btn-anti-default" @click="handleCancel">取消</a>
        <a href="javascript:" class="btn btn btn-solid-primary" @click="handleSubmit">提交</a>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import util from '../../libs/util'
import Grid from '../../components/grid/grid.vue'
import GridTopMenu from '../../components/grid-menu/grid-top-menu'
import DialogForm from '../../components/grid/dialog-form'
import GridBasicConfig from '../grid-manage/grid-basic-config.vue'
import GridColumnConfig from '../grid-manage/grid-column-config.vue'
import GridMenuConfig from '../grid-manage/grid-menu-config.vue'

export default {
  components: {
    GridTopMenu,
    Grid,
    DialogForm,
    GridBasicConfig,
    GridColumnConfig,
    GridMenuConfig
  },
  name: 'sa-base-category-manage',
  data() {
    return {
      loading: false,
      gridConfigUrl: '',
      copyDialogVisible: false,
      webSites: [],
      // 表单数据对象
      ruleForm: {
        newBaseCategoryName: '',
        newBaseCategoryCode: '',
        siteId: '',
        isCopyGrid: 'true',
        isCopyInterface: 'true',
        sourceBaseCategoryId: '',
        comment: ''
      },
      // 表单校验规则
      rules: {
        'newBaseCategoryName': {
          type: 'string',
          required: true, // 是否必填
          max: 20,
          message: '请输入复制后名称,长度不大于20字符',
          trigger: 'change'
        },
        'newBaseCategoryCode': {
          type: 'string',
          required: false, // 是否必填
          max: 50,
          message: '请输入复制后编号,长度不大于50字符',
          trigger: 'change'
        }
      }
    }
  },
  created() {
    this.gridConfigUrl = this.$route.meta.url
    this.loadWebSites()
  },
  computed: {
  },
  methods: {
    // 加载webSite
    loadWebSites() {
      util.ajax.post('/superAdmin/permissionManage/getAllWebSites').then((res) => {
        if (res.data.meta.errCode === 0) {
          this.webSites = res.data.data
        } else {
          this.$notify.info({title: '提示', message: '获取站点数据失败：' + res.data.meta.errMsg})
        }
      }).catch((err) => {
        this.$notify.error({title: '错误', message: '获取站点数据失败：'})
        console.error(err)
      })
    },
    // 打开dialog时
    handleDialogOpen() {
      let selectedRows = this.$refs.myGrid.getSelectedRows()
      this.$set(this.ruleForm, 'newBaseCategoryName', selectedRows[0].name + '(复制)')
      this.$set(this.ruleForm, 'newBaseCategoryCode', selectedRows[0].code)
      this.$set(this.ruleForm, 'sourceBaseCategoryId', selectedRows[0].id)
      this.$set(this.ruleForm, 'siteId', '')
      this.$set(this.ruleForm, 'comment', selectedRows[0].comment)
    },
    // 关闭dialog时
    handleDialogClose() {
    },
    checkSelect() {
      if (this.$refs.myGrid.checkedRows.length > 1) {
        this.$notify.info({title: '提示', message: '仅支持复制单个基础功能'})
        return false
      } else {
        return true
      }
    },
    // 复制基础功能按钮点击事件
    handleCopyBaseCategory() {
      if (this.checkSelect()) {
        this.copyDialogVisible = true
      }
    },
    // 复制基础功能提交表单
    handleSubmit() {
      this.$refs['ruleForm'].validate((valid) => {
        let params = {...this.ruleForm}
        this.loading = true
        util.ajax.post('/superAdmin/baseCategoryManage/copyBaseCategory', {params}).then(res => {
          this.loading = false
          if (res.data.meta.errCode === 0) {
            this.$notify.success({title: '成功', message: '复制成功'})
            this.copyDialogVisible = false
            this.$refs.myGrid.loadTableData()
          } else {
            this.$notify.error({title: '错误', message: res.data.meta.errMsg})
          }
        }).catch((err) => {
          this.loading = false
          console.error(err)
          this.$message.error('复制失败!')
        })
      })
    },
    handleCancel() {
      this.copyDialogVisible = false
    }
  }
}
</script>
<style lang="scss">
.sa-base-category-manage {
  height: 100%;

  .el-form-item {
    margin-bottom: 0;
  }
  .form-table-wrap {
    margin: 0;
    padding: 8px 12px 8px 12px;
    line-height: 1;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}

.form-table-row {
  border-bottom: 1px solid #eee;
  vertical-align: bottom;
}



</style>



// WEBPACK FOOTER //
// src/super-admin/base-category/sa-base-category-manage.vue